import React from 'react';
import {alpha, Box} from '@mui/material';
import {ItemTypes} from '../util/itemTypes';

export const ArdDefaultBackground = ({
  item,
  value,
  mapScale,
  locationLocked,
  isHidden
}) => {
  return (
    <Box
      sx={{
        fontSize: 55 * mapScale + 'px',
        color: 'white',
        width: '100%',
        height: '50%',
        display: 'flex'
      }}
      data-item-id={item.id}>
      <Box
        sx={{
          width: '100%',
          height: '100%',
          display: 'flex',
          p: 0.25
        }}>
        <Box
          sx={theme => ({
            textAlign: 'center',
            flexBasis: '100%',
            height: '100%',
            mx: 0.25,
            mt: 0.25,
            backgroundColor: isHidden
              ? alpha(theme.palette.grey[500], 0.4)
              : item.type === ItemTypes.TEMPERATURE
              ? alpha('#ff0000', 0.6)
              : alpha('#fff', 0.5),
            color: isHidden
              ? alpha('#000', 0.4)
              : theme.palette.primary.contrastText,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: `${theme.shape.borderRadius}px`,
            fontSize: '27.5px',
            fontWeight: theme.typography.fontWeightBold,
            border: locationLocked ? 'transparent' : 'dashed 2px white',
            userSelect: 'none'
          })}>
          {value}
        </Box>
      </Box>
    </Box>
  );
};

export default ArdDefaultBackground;
